import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import {
  Box,
  Typography,
  Tabs,
  Tab,
  Paper
} from '@mui/material';
import { MapPin as LocationsLogoIcon } from 'lucide-react';
import PublicIcon from '@mui/icons-material/Public';
import MapIcon from '@mui/icons-material/Map';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import CountriesTab from './locations/CountriesTab';
import RegionsTab from './locations/RegionsTab';
import CitiesTab from './locations/CitiesTab';

const Locations = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [value, setValue] = useState(0);

  useEffect(() => {
    const tabParam = searchParams.get('tab');
    if (tabParam) {
      const tabIndex = parseInt(tabParam, 10);
      if (!isNaN(tabIndex) && tabIndex >= 0 && tabIndex <= 2) {
        setValue(tabIndex);
      }
    }
  }, [searchParams]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setSearchParams({ tab: newValue });
  };

  return (
    <Box>
      <Box sx={{ mb: 4, display: 'flex', alignItems: 'center', gap: 1.5, justifyContent: 'space-between' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Box
            sx={{
              width: 40,
              height: 40,
              borderRadius: '50%',
              bgcolor: '#eef2ff',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <LocationsLogoIcon size={20} color="#4f46e5" />
          </Box>
          <Box>
            <Typography variant="h4" gutterBottom fontWeight="bold" color="primary">
              Gestione Località
            </Typography>
            <Typography variant="body1" color="text.secondary">
              Gestisci nazioni, regioni e città del sistema.
            </Typography>
          </Box>
        </Box>
      </Box>

      <Paper sx={{ width: '100%', mb: 2 }}>
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          centered
        >
          <Tab icon={<PublicIcon />} label="Nazioni" />
          <Tab icon={<MapIcon />} label="Regioni" />
          <Tab icon={<LocationCityIcon />} label="Città" />
        </Tabs>
      </Paper>

      <Box sx={{ mt: 2 }}>
        {value === 0 && <CountriesTab />}
        {value === 1 && <RegionsTab />}
        {value === 2 && <CitiesTab />}
      </Box>
    </Box>
  );
};

export default Locations;
